export const GoogleAnalyticsEvents = {
    VIEW_SCRUBBER_SAVINGS_FLEET: 'view-scrubber-savings-fleet',
    OPEN_SHIP_SIDE_PANEL: 'open-ship-side-panel',
    OPEN_SCRUBBER_DAYS_MODAL: 'open-scrubber-days-modal',
    VIEW_AVERAGE_BUNKER_PRICE: 'view-average-bunker-price',
    OPEN_POOL_POINT_MODAL: 'open-pool-point-modal',
    OPEN_OPERATING_DAYS_MODAL: 'open-operating-days-modal',
    DOWNLOAD: 'download'
};

export const GoogleAnalyticsModules = {
    DISTRIBUTION: 'distribution',
    SCRUBBER: 'scrubber',
    LNG: 'lng'
};

export const GoogleAnalyticsDownloadTypes = {
    PDF_FULL: 'pdf-full',
    XLS_FULL: 'xls-full',
    PDF_FILTERED: 'pdf-filtered',
    XLS_FILTERED: 'xls-filtered'
};

export const SHOW_BANNER_START_DAY = 1
export const CALCULATION_SCHEDULE_DAY = 7


